<!--begin::Main-->
<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
    [fullScreen]="true">
    <span class="loader">
        <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
    </span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">

        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading">
                            <svg width="44" height="29" viewBox="0 0 44 29" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_917_3418)">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M33.9088 5.61834C33.3565 5.61834 32.9088 6.06605 32.9088 6.61834V19.3921H28.7379V0.999999C28.7379 0.447715 28.2902 0 27.7379 0H25.0855C24.5332 0 24.0855 0.447715 24.0855 1V19.3921H19.9145V12.6646C19.9145 12.1123 19.4668 11.6646 18.9145 11.6646H16.2621C15.7098 11.6646 15.2621 12.1123 15.2621 12.6646V19.3921H11.0849V8.81921C11.0849 8.26693 10.6372 7.81921 10.0849 7.81921H7.43252C6.88023 7.81921 6.43252 8.26693 6.43252 8.81921V19.3921H4V21H40V19.3921H37.5737V6.61834C37.5737 6.06605 37.126 5.61834 36.5737 5.61834H33.9088Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_917_3418" x="0" y="0" width="44" height="29"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_917_3418" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_917_3418"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>


                            Evaluation
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Accueil</a>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">Evaluation</li>

                        <li class="breadcrumb-item">
                            <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">liste des évaluations</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->
        <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class="card">
                    <!--begin::Card header-->
                    <form [formGroup]="searchForm">
                        <div class="card-body tools">
                            <div class="title mb-10">
                                <h4>Recherche</h4>
                            </div>
                            <div>
                                <div class="row mb-3">
                                    <div class="col-lg-3">
                                        <input type="text" formControlName="name_eval" id="Nom"
                                            class="form-control form-control-solid mb-3" placeholder="Nom évaluation">
                                    </div>
                                    <div class="col-lg-3">
                                        <input type="text" formControlName="name_consultant" id="Nom"
                                            class="form-control form-control-solid mb-3" placeholder="Nom consultant">
                                    </div>
                                    <div class="col-lg-3">
                                        <ng-select formControlName="type_eval" class="mb-3"
                                            [notFoundText]="'Aucun élément trouvé'" [items]="typeList" bindLabel="name"
                                            bindValue="id" [placeholder]="'Type'" autoComplete>
                                        </ng-select>
                                    </div>
                                    <div class="col-lg-3">
                                        <ng-select formControlName="status_eval" class="mb-3"
                                            [notFoundText]="'Aucun élément trouvé'" [items]="statusList"
                                            bindLabel="name" bindValue="id" [placeholder]="'Statut'" autoComplete>
                                        </ng-select>
                                    </div>
                                    <div class="col-lg-3 calenderDate">
                                        <p-calendar [style]="{'border': 'none','margin-top': '-6px'}"
                                            dateFormat="dd/mm/yy" placeholder="Date de début" inputId="yearpicker"
                                            formControlName="start_date" class="form-control">
                                        </p-calendar>

                                    </div>
                                    <div class="col-lg-3 calenderDate">
                                        <p-calendar [style]="{'border': 'none','margin-top': '-6px'}"
                                            dateFormat="dd/mm/yy" placeholder="Date de fin" inputId="yearpicker"
                                            formControlName="end_date" class="form-control"></p-calendar>
                                        <!-- <input type="date" formControlName="end_date" id="date" class="form-control form-control-solid mb-3" placeholder="Date de fin "> -->
                                    </div>
                                    <div class="col-lg-3"></div>
                                    <div class="col-lg-3"></div>
                                    <div class="col-lg-3"></div>

                                    <div class="mb-3 search-btn d-flex justify-content-end">
                                        <div class="align-items-center recherche">
                                            <button type="button" class="me-5"
                                                (click)="currentPage = 0; getTemplateListEsn()">
                                                <svg width="15" height="15" viewBox="0 0 20 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                                        fill="white" />
                                                </svg>
                                                Rechercher</button>
                                        </div>
                                        <div class="resett-btn">
                                            <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip"
                                                data-bs-placement="top" title="Réinitialiser">
                                                <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt=""
                                                        width="30px"></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!--end::Content container-->
        </div>
        <!--begin::Content-->

        <div id="kt_app_content" class="app-content flex-column-fluid mb-5">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class="card content-table">

                    <!--begin::Card header-->
                    <div class="d-flex flex-wrap header-grid align-items-center">
                        <div class="section_title">
                            <h1 class="section-heading my-5">Liste des évaluations</h1>
                        </div>
                        <!--begin::Wrapper-->
                        <div class="filter-tools mt-10 mb-10">
                            <div class="filter">

                            </div>
                            <ul class="nav nav-pills me-5">
                                <li class="nav-item m-0">
                                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary  me-3"
                                        data-bs-toggle="tab" href="#kt_project_targets_card_pane">
                                        <i class="ki-duotone ki-element-plus fs-1">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                            <span class="path3"></span>
                                            <span class="path4"></span>
                                            <span class="path5"></span>
                                        </i>
                                    </a>
                                </li>
                                <li class="nav-item m-0">
                                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                                        data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                                        <i class="ki-duotone ki-row-horizontal fs-2">
                                            <span class="path1"></span>
                                            <span class="path2"></span>
                                        </i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!--end::Wrapper-->
                    </div>

                    <!--end::Card header-->
                    <!--begin::Card body-->
                    <div class="card-body pt-0">
                        <div class="tab-content for-web">
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_card_pane" class="tab-pane fade ">
                                <!--begin::Row-->
                                <div class="card-body pt-0 pb-0">
                                    <div class="row g-6 g-xl-9 justify-content-center" *ngIf="templatesListESN?.length;">
                                        <div class="col-md-6 col-xxl-4" *ngFor="let template of templatesListESN">
                                                <div class="card pt-5 p-5">
                                                    <div class="poste">
                                                        <span class="badge hybrid">{{template?.type }}
                                                        </span>
                                                        <span class="tag"
                                                            [ngClass]="template.status === statusEnum.Envoye || template.status === statusEnum.Rempli ? 'sent' : 'received'">
                                                            {{ getStatusLabel(template.status) }}
                                                        </span>
                                                    </div>
                                                    <div class="card-header flex-nowrap border-0 pt-9">
                                                        <div class="card-title m-0">

                                                            <div class="symbol symbol-65px symbol-circle mb-5">
                                                                <img *ngIf="template.consultant?.image_url;"
                                                                    class="table-img"
                                                                    src="{{urlImage + template.consultant?.image_url}}"
                                                                    alt="" width="50px">
                                                                <img *ngIf="!template.consultant?.image_url"
                                                                    class="table-img" src="/assets/media/avatar.png"
                                                                    alt="avatar">

                                                            </div>
                                                            <div class="esn-name">
                                                                {{template.consultant?.first_name}}
                                                                {{template.consultant?.last_name}}</div>
                                                            <span class="name-eval"> {{template.name ? template.name
                                                                :'---'}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="sep"></div>
                                                    <div class="foot p-5">
                                                        <div class="plus">
                                                            <a class="dropdown-item cursor-pointer"
                                                                routerLink="/evaluation/details-evaluation/{{template.id}}">Visualiser</a>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                    <app-empty-state *ngIf="!templatesListESN?.length && !loadSpinnerTable"
                                        [title]="parentItem"></app-empty-state>
                                    <div class="pagination mt-5 pt-5" *ngIf="templatesListESN?.length">
                                        <mat-paginator [length]="totalElements" [pageSize]="pageSize"
                                            [showFirstLastButtons]="true" [pageSizeOptions]="pageSizeOptions"
                                            [pageIndex]="currentPage" (page)="onPageChange($event)"
                                            aria-label="Select page">
                                        </mat-paginator>
                                    </div>
                                </div>
                                <!--end::Row-->
                            </div>
                            <!--end::Tab pane-->
                            <!--begin::Tab pane-->
                            <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                                <div class="content">
                                    <div class="card-body pt-0 pb-0">
                                        <!--begin::Table-->
                                        <div class="table-responsive" *ngIf="templatesListESN?.length">
                                            <table class="table align-middle fs-6 gy-5 style-table"
                                                id="kt_customers_table">
                                                <thead>
                                                    <tr
                                                        class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                        <th class="min-w-125px"> <span>Photo </span></th>
                                                        <th class="min-w-125px"><span>Nom consultant</span></th>
                                                        <th class="min-w-125px"><span>Nom evaluation</span></th>
                                                        <th class="min-w-125px"><span>type</span></th>
                                                        <th class="min-w-125px"><span>Date</span></th>
                                                        <th class="min-w-125px"><span>Statut</span></th>
                                                        <th class="min-w-90px"><span>Actions</span></th>
                                                    </tr>
                                                </thead>
                                                <ng-container *ngIf="templatesListESN?.length">
                                                    <tbody class="fw-semibold text-gray-600">
                                                        <tr *ngFor="let template of templatesListESN">
                                                            <td>
                                                                <img *ngIf="template.consultant?.image_url; else noImage"
                                                                    class="table-img"
                                                                    src="{{urlImage + template.consultant?.image_url}}"
                                                                    alt="" width="50px">
                                                                <ng-template #noImage>
                                                                    <img class="table-img"
                                                                        src="/assets/media/avatar.png" alt="avatar"
                                                                        width="50px">
                                                                </ng-template>
                                                            </td>

                                                            <td>
                                                                <span
                                                                    class="esn-name">{{template.consultant?.first_name}}
                                                                    {{template.consultant?.last_name}}</span>
                                                            </td>
                                                            <td>
                                                                <span class="eval-name">{{template.name ? template.name
                                                                    :'---'}}</span>
                                                            </td>

                                                            <td>
                                                                <span class="tag"
                                                                    [ngClass]="template.type === 'Suivi' ? 'remote' : 'hybrid'">{{template.type}}</span>
                                                            </td>

                                                            <td>
                                                                <span
                                                                    [ngbTooltip]="getDateTooltip(template) ? getDateTooltip(template) : null">
                                                                    {{ getDateByStatus(template) ?
                                                                    (getDateByStatus(template) | date:'dd/MM/yyyy') :
                                                                    '---' }}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <span class="tag"
                                                                    [ngClass]="template.status === statusEnum.Envoye || template.status === statusEnum.Rempli ? 'sent' : 'received'">
                                                                    {{ getStatusLabel(template.status) }}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <div class="tools">
                                                                    <div class="dropdown">
                                                                        <button mat-button [matMenuTriggerFor]="menu"
                                                                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                                            type="button" id="dropdownMenuButton"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-haspopup="true" aria-expanded="false">
                                                                            <svg width="19" height="5"
                                                                                viewBox="0 0 19 5" fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg">
                                                                                <circle cx="2.44739" cy="2.44739"
                                                                                    r="2.44739"
                                                                                    transform="matrix(1 0 0 -1 0 4.89478)"
                                                                                    fill="#265D91" />
                                                                                <circle cx="2.44739" cy="2.44739"
                                                                                    r="2.44739"
                                                                                    transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                                                    fill="#265D91" />
                                                                                <circle cx="2.44739" cy="2.44739"
                                                                                    r="2.44739"
                                                                                    transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                                                    fill="#265D91" />
                                                                            </svg></button>
                                                                        <mat-menu #menu="matMenu">
                                                                            <button mat-menu-item
                                                                                routerLink="/evaluation/details-evaluation/{{template.id}}">
                                                                                Visualiser
                                                                            </button>
                                                                            <button mat-menu-item
                                                                                *ngIf="isEvalOwner(template)"
                                                                                [ngClass]="{
                                                                                'disabled-link': !isSendEnable(template)}"
                                                                                (click)="isSendEnable(template) && sendPV(template)">
                                                                                Envoyer
                                                                            </button>
                                                                            <button mat-menu-item
                                                                                [ngClass]="{
                                                                                'disabled-link': !isSendEnable(template)}"
                                                                                (click)="isSendEnable(template) && openModalReport(pv_report, template)">
                                                                                Voir compte rendu
                                                                            </button>
                                                                        </mat-menu>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </ng-container>
                                            </table>
                                        </div>
                                        <div class="pagination mt-4" *ngIf="templatesListESN?.length">
                                            <mat-paginator [length]="totalElements" [pageSize]="pageSize"
                                                [showFirstLastButtons]="true" [pageSizeOptions]="pageSizeOptions"
                                                [pageIndex]="currentPage" (page)="onPageChange($event)"
                                                aria-label="Select page">
                                            </mat-paginator>
                                        </div>
                                        <app-empty-state *ngIf="templatesListESN?.length < 1"
                                            [title]="parentItem"></app-empty-state>
                                    </div>
                                </div>
                            </div>
                            <!--end::Tab pane-->
                        </div>
                        <div class="tab-content for-mobile">
                            <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                                <div class="card-body pt-0 pb-0">
                                    <div class="row g-6 g-xl-9 justify-content-center" *ngIf="templatesListESN?.length;">
                                        <div class="col-md-6 col-xxl-4" *ngFor="let template of templatesListESN">
                                            <div class="card pt-5 p-5">
                                                <div class="poste">
                                                    <span class="badge hybrid">{{template?.type }}
                                                    </span>
                                                    <span class="tag"
                                                        [ngClass]="template.status === statusEnum.Envoye || template.status === statusEnum.Rempli ? 'sent' : 'received'">
                                                        {{ getStatusLabel(template.status) }}
                                                    </span>
                                                </div>
                                                <div class="card-header flex-nowrap border-0 pt-9">
                                                    <div class="card-title m-0">

                                                        <div class="symbol symbol-65px symbol-circle mb-5">
                                                            <img *ngIf="template.consultant?.image_url;"
                                                                class="table-img"
                                                                src="{{urlImage + template.consultant?.image_url}}"
                                                                alt="" width="50px">
                                                            <img *ngIf="!template.consultant?.image_url"
                                                                class="table-img" src="/assets/media/avatar.png"
                                                                alt="avatar">

                                                        </div>
                                                        <div class="esn-name">
                                                        {{template.consultant?.first_name ?
                                                        template.consultant?.first_name : '---'}}
                                                        {{template.consultant?.last_name ?
                                                        template.consultant?.last_name : '---'}}</div>
                                                        <span class="name-eval"> {{template.name ? template.name
                                                            :'---'}}</span>
                                                    </div>
                                                </div>
                                                <div class="sep"></div>
                                                <div class="foot pt-5">
                                                    <div class="plus">
                                                        <a class="dropdown-item cursor-pointer"
                                                            routerLink="/evaluation/details-evaluation/{{template.id}}">Visualiser</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <app-empty-state *ngIf="!templatesListESN?.length && !loadSpinnerTable"
                                        [title]="parentItem"></app-empty-state>
                                    <div class="pagination mt-5 pt-5" *ngIf="templatesListESN?.length">
                                        <mat-paginator [length]="totalElements" [pageSize]="pageSize"
                                            [showFirstLastButtons]="true" [pageSizeOptions]="pageSizeOptions"
                                            [pageIndex]="currentPage" (page)="onPageChange($event)"
                                            aria-label="Select page">
                                        </mat-paginator>
                                    </div>
                                </div>
                                <!--end::Row-->
                            </div>
                        </div>

                        <!--end::Table-->
                    </div>

                    <!--end::Card body-->

                </div>
                <!-- <ng-template #emptyList>
                    <div class="alert alert-warning text-center mt-5" role="alert">
                        <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                        <span class="empty-list">
                            La liste est vide
                        </span>
                    </div>
                </ng-template> -->
            </div>
            <!--end::Content container-->
        </div>
        <!--end::Content-->
    </div>
    <!--end::Content wrapper-->
    <!--begin::Footer-->

    <!--end::Footer-->
    <!--end:::Main-->
</div>


<ng-template #pv_report let-modal class="modal-dialog-centered">
    <div class="modal-dialog-centered">
        <div class="modal-content pt-5 pb-15">
            <div class="modal-header">
                <h2 class="fw-bold">Compte rendu</h2>
                <div (click)="closeModal()" id="kt_customers_export_close"
                    class="btn btn-icon btn-sm btn-active-icon-primary">
                    <i class="ki-duotone ki-cross fs-1" data-bs-dismiss="modal">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </div>
            </div>

            <div class="modal-body rendu-compte mx-5 my-7">
                <div class="rendu-warapper">
                    <span [innerHTML]="safeDescription"></span>
                </div>
            </div>
        </div>
    </div>
</ng-template>